module.exports = __webpack_public_path__ + "img/25.5e44d0b4.jpg";